/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  DatePicker,
  Flex,
  Select,
  Typography,
  Divider,
} from 'antd';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import { useLanguage } from 'hooks/Language/useLanguage';
import {
  Calendar,
  CreditCard,
  Mail,
  FileText,
  Download,
  Eye,
} from 'lucide-react';
import TransactionViewDrawer from './TransactionViewDrawer';
import './index.scss';

dayjs.extend(customParseFormat);
const dateFormat = 'YYYY-MM-DD';

const { Text } = Typography;

const GetStatement = ({ userData, cardItem, getStatement }: any) => {
  const { translate } = useLanguage();
  const {
    onHandleRequestStatement,
    loadTransaction,
    onChangeDateFrom,
    onChangeDateTo,
    dateForm,
    dateTo,
    selectedFile,
    onHandleSelectedFile,
    onHandleExportFile,
    isExporting,
    loadTransactionStatement,
    openTransactionViewDrawer,
    onCloseTransactionViewDrawer,
    transactionViewList,
    selectedAccount,
  } = getStatement;

  const isViewMode = selectedFile === 'view';
  const isLoading = loadTransactionStatement || loadTransaction;

  return (
    <div className="get-statement-container">
      <div className="info-card">
        <Flex
          justify="space-between"
          align="center"
          className="info-item"
        >
          <Flex gap="small" align="center">
            <CreditCard size={16} className="text-secondary" />
            <Text type="secondary">
              {translate('Account number')}
            </Text>
          </Flex>
          <Text strong copyable>
            {cardItem?.AccountNumber}
          </Text>
        </Flex>
        <Divider style={{ margin: '12px 0' }} />
        <Flex
          justify="space-between"
          align="center"
          className="info-item"
        >
          <Flex gap="small" align="center">
            <Mail size={16} className="text-secondary" />
            <Text type="secondary">{translate('Email')}</Text>
          </Flex>
          <Text strong>{userData?.[0]?.Emails?.[0]?.Email}</Text>
        </Flex>
      </div>

      <Flex vertical gap="large">
        <Flex gap="middle" wrap="wrap">
          <Flex vertical flex={1} gap="small">
            <Text className="section-label">
              <Calendar size={14} style={{ marginRight: 8 }} />
              {translate('Start Date')}
            </Text>
            <div className="date-picker-container">
              <DatePicker
                style={{ width: '100%' }}
                placeholder={`${dayjs('2023-06-10', dateFormat)}`}
                minDate={dayjs('2019-08-01', dateFormat)}
                onChange={onChangeDateFrom}
              />
            </div>
          </Flex>
          <Flex vertical flex={1} gap="small">
            <Text className="section-label">
              <Calendar size={14} style={{ marginRight: 8 }} />
              {translate('End Date')}
            </Text>
            <div className="date-picker-container">
              <DatePicker
                style={{ width: '100%' }}
                placeholder={`${dayjs('2024-06-10', dateFormat)}`}
                minDate={dayjs('2019-08-01', dateFormat)}
                onChange={onChangeDateTo}
              />
            </div>
          </Flex>
        </Flex>

        <Flex vertical gap="small">
          <Text className="section-label">
            <FileText size={14} style={{ marginRight: 8 }} />
            {translate('Format')}
          </Text>
          <Select
            defaultValue={'pdf'}
            placeholder={translate('Choose File Format')}
            style={{ width: '100%' }}
            onChange={onHandleSelectedFile}
            value={selectedFile}
            options={[
              {
                label: (
                  <Flex align="center" gap={8}>
                    <Eye size={14} />
                    {translate('View Transactions')}
                  </Flex>
                ),
                value: 'view',
              },
              { label: 'PDF Document (.pdf)', value: 'pdf' },
              { label: 'CSV Spreadsheet (.csv)', value: 'csv' },
              { label: 'Excel Spreadsheet (.xls)', value: 'xls' },
            ]}
          />
        </Flex>

        <Button
          type="primary"
          size="large"
          className="action-button"
          disabled={!dateForm || !dateTo}
          onClick={onHandleExportFile}
          loading={isLoading}
          icon={
            isViewMode ? <Eye size={18} /> : <Download size={18} />
          }
        >
          {isViewMode ? translate('View') : translate('Download')}
        </Button>

        <TransactionViewDrawer
          open={openTransactionViewDrawer}
          onClose={onCloseTransactionViewDrawer}
          transactions={transactionViewList || []}
          loading={loadTransaction}
          accountNumber={
            selectedAccount?.AccountNumber || cardItem?.AccountNumber
          }
          startDate={dateForm}
          endDate={dateTo}
        />
      </Flex>
    </div>
  );
};

export default GetStatement;
